import { MAX_TAG_NAME_LENGTH } from '@constants/generic';

export const MIN_INPUT_LENGTH = 3;
export const MAX_INPUT_LENGTH = MAX_TAG_NAME_LENGTH;
export const DEFAULT_MAX_MANUAL_TAGS = 15;
